import { render, staticRenderFns } from "./AubeCoinMembershipFeePolicy.vue?vue&type=template&id=43342bcc&scoped=true&"
import script from "./AubeCoinMembershipFeePolicy.vue?vue&type=script&lang=js&"
export * from "./AubeCoinMembershipFeePolicy.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinMembershipFeePolicy.vue?vue&type=style&index=0&id=43342bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43342bcc",
  null
  
)

export default component.exports